// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import appHistory from 'app-history';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import Ticket from 'services/data/ticket';

// Components
import { Page, PageContent, PageHeader } from 'components/page';
import AddPurchaseOrder from 'components/models/purchases/add-purchase-order';


// Component
class AddPurchaseOrderPage extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object,
    ticketId: PropTypes.string
  };

  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() {
    if (this.props.ticketId) {
      this.setState({ loadingTicket: true });

      Ticket.findOne(this.props.ticketId, { load: 'agreement' })
        .then((ticket) => {
          this.setState({
            ticket,
            loadingTicket: false
          });
        })
        .catch(alerts.catchError);
    }
  }
  
  onCreate(purchaseOrder) {
    appHistory.push({ pathname: '/purchases', query: { where: { id: purchaseOrder.id } } });
  }

  render() {
    const { currentUser } = this.props;

    return (
      <Page>
        <PageHeader title="Add Purchase Order" />
        <PageContent className="add-purchase bg-medium-blue-grey">
          { !this.state.loadingTicket &&
            <AddPurchaseOrder currentUser={currentUser} ticket={this.state.ticket} onCreate={this.onCreate} />
          }
        </PageContent>
      </Page>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    currentUser: state.auth.currentUser,
    ticketId: ownProps.location.query.ticket
  };
}

export default connect(mapStateToProps)(AddPurchaseOrderPage);



// WEBPACK FOOTER //
// ./app/routes/purchases/add-purchase-order.js